import 'vuetify/src/stylus/app.styl';
import {
	Vuetify,
	VAlert,
	VApp,
	VBreadcrumbs,
	VBtn,
	VBtnToggle,
	VCard,
	VCheckbox,
	VChip,
	VCombobox,
	VDataIterator,
	VDatePicker,
	VDialog,
	VDivider,
	VForm,
	VGrid,
	VIcon,
	VList,
	VMenu,
	VNavigationDrawer,
	VRadioGroup,
	VSelect,
	VSlider,
	VSnackbar,
	VSubheader,
	VTextField,
	VTextarea,
	VTimePicker,
	VToolbar,
	VTooltip,
	transitions,
	VExpansionPanel,
	VDataTable,
	VProgressLinear,
	VTabs,
	VStepper,
	VSwitch,
	VAutocomplete,
} from 'vuetify';

export default function (Vue) {
	Vue.use(
		Vuetify,
		{
			components: {
				VAlert,
				VApp,
				VBreadcrumbs,
				VBtn,
				VBtnToggle,
				VCheckbox,
				VChip,
				VCard,
				VCombobox,
				VDataIterator,
				VDatePicker,
				VDialog,
				VDivider,
				VForm,
				VGrid,
				VIcon,
				VList,
				VMenu,
				VNavigationDrawer,
				VRadioGroup,
				VSelect,
				VSlider,
				VSnackbar,
				VSubheader,
				VTextField,
				VTextarea,
				VTimePicker,
				VToolbar,
				VTooltip,
				transitions,
				VExpansionPanel,
				VDataTable,
				VProgressLinear,
				VTabs,
				VStepper,
				VSwitch,
				VAutocomplete,
			},
			theme: {
				primary: '#1A4338',
				secondary: '#DCEAE4',
				accent: '#12372E',
				error: '#FF5253',
				info: '#2E6B59',
				success: '#4DC68C',
				warning: '#FFB74C',
				pink: '#fe6b7d',
				base: '#1A4338',
			},
		},
	);
}



// WEBPACK FOOTER //
// ./src/vuetify.js